import React from 'react'
import { BlockTypes } from 'enum/block-type.enum'
import { ILessonContent } from 'store/states/lessons.state'
import { sanitizeHtml } from 'helpers/sanitizeHtml'
import { IEvaluationResume } from 'models/evaluation.model'
import Multimedia from '../components/multimedia/Multimedia'
import RichText from '../components/rich-text/RichText'
import { Survey } from '../components/survey/Survey'
import Task from '../components/task/Task'
import { ContentEvaluation } from '../components/evaluation/ContentEvaluation'
import Scorm from '../components/Scorm'
import { Meeting } from '../components/Meeting'
import { SessionBlock } from '../components/SessionBlock'
import { MandatoryBlock } from './MandatoryBlock'
import styles from './GenerateContent.module.scss'

interface GenerateContentProps {
  lessonId: number
  lessonContent: ILessonContent[]
  refArray: React.MutableRefObject<any[]>
  canEdit: boolean
  count: React.MutableRefObject<number>
  showEvaluation: (evaluation: IEvaluationResume) => void
  location: any
  reload: () => void
  next?: () => void
  courseId: number
}

export const GenerateContent = ({
  lessonContent,
  refArray,
  canEdit,
  count,
  showEvaluation,
  reload,
  next,
  courseId,
}: GenerateContentProps) => {
  const content = [] as any
  count.current = 0
  lessonContent.forEach((item, index: number) => {
    const key = item.id + '-' + item.type

    switch (item.type) {
      case BlockTypes.BlockSurvey:
        {
          const mandatory = item.questionsForms.some(
            (question) => question.mandatory
          )
          content.push(
            <div key={key}>
              <MandatoryBlock content={item} isMandatory={mandatory} />
              <Survey
                id={item.id}
                questionList={item.questionsForms}
                canEdit={canEdit}
                refArray={refArray}
                count={count}
                lessonIndex={index}
              />
            </div>
          )
        }
        break
      case BlockTypes.BlockMeeting:
        content.push(
          <div key={key}>
            <Meeting data={item} />
          </div>
        )
        break
      case BlockTypes.BlockSession:
        content.push(
          <div key={key}>
            <MandatoryBlock content={item} isMandatory={item.mandatory} />
            <SessionBlock data={item} />
          </div>
        )
        break
      case BlockTypes.BlockRichText:
        content.push(
          <div key={key}>
            <RichText data={item}>
              <div className={styles.title}>{item.name}</div>
            </RichText>
          </div>
        )
        break
      case BlockTypes.BlockTask:
        content.push(
          <div key={key}>
            <MandatoryBlock content={item} isMandatory={item.mandatory} />
            <Task
              id={item.id}
              data={item}
              canEdit={canEdit}
              refArray={(el: any) => {
                if (item.mandatory) {
                  refArray.current[count.current] = el
                  count.current++
                }
              }}
              index={index}
            />
          </div>
        )
        break
      case BlockTypes.BlockMultimedia:
        {
          const description = item.description.replace(
            /(?:\r\n|\r|\n)/g,
            '<br>'
          )
          content.push(
            <div key={key}>
              {(item.description || (item.name && item.showTitle)) && (
                <div>
                  {item.showTitle && (
                    <h2 className={styles.title}> {item.name}</h2>
                  )}
                  <div
                    className={styles.description}
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHtml(description),
                    }}
                  ></div>
                </div>
              )}
              <Multimedia data={item} courseId={courseId} />
            </div>
          )
        }
        break
      case BlockTypes.BlockScorm: {
        content.push(
          <div key={key}>
            {(item.description || (item.name && item.showTitle)) && (
              <div>
                {item.showTitle && (
                  <h2 className={styles.title}> {item.name}</h2>
                )}
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(
                      item.description.replace(/(?:\r\n|\r|\n)/g, '<br>')
                    ),
                  }}
                />
              </div>
            )}
            <Scorm data={item} reload={reload} next={next} />
          </div>
        )
        break
      }
      case BlockTypes.Evaluation:
        content.push(
          <div key={key}>
            <ContentEvaluation
              id={item.id}
              name={item.name}
              description={item.description}
              showEvaluation={(evaluation) => showEvaluation(evaluation)}
            />
          </div>
        )
        break
      default:
        break
    }
  })
  return content
}
